import React, {useState} from 'react';
import 'katex/dist/katex.min.css';
import 'katex/contrib/mhchem';
import classNames from "classnames";
import {TermWrapper} from "./TermWrapper";
import {CustomLatex} from "../../components/CustomLatex";


export function TextContent(props) {

    const [toggleHover, setToggleHover] = useState(false);


    const textClass = classNames("course-text " + props.className);

    const stylingNormal = {};


    function renderText() {
        const parts = props.value.split(/(\$+.*?\$+)/);
        const children = [];

        parts.forEach((part, index) => {
            if (part.includes('$')) {
                // If the part contains LaTeX, render it as a <Latex> component
                children.push(<CustomLatex text={part}/>);
            } else {


                // Split the part into words to check each word
                const words = part.split(/\s+/).map((word, idx) => {
                    // Check if the word is in the predefined list
                    if(props.level === 0 && props.terms != null) {
                        const term = props.terms.find(term => word.toLowerCase() === term.term.toLowerCase())
                        if (term) {
                            // If it is, wrap it with a <strong> tag
                            return <TermWrapper key={idx} term={term}>{word}</TermWrapper>;
                        }
                    }
                    return word;
                });

                // Join the words back into a string and add to children array
                children.push(...words.reduce((acc, word, idx) => {
                    if (idx > 0) {
                        acc.push(" ");
                    }
                    acc.push(word);
                    return acc;
                }, []));

            }
        });

        switch (props.level) {
            default:
            case 0:
                return (<p onClick={() => {
                    if(props.selectable) {

                        props.onClickCallback(props)
                    }
                    }} onMouseEnter={() => setToggleHover(props.selectable)} onMouseLeave={() => setToggleHover(false)} className={textClass} style={stylingNormal}>{children}</p>);
            case 1:
                return (<h2 className={textClass}>{children}</h2>);
            case 2:
                return (<h3 className={textClass}>{children}</h3>);
            case 3:
                return (<h4 className={textClass}>{children}</h4>);
            case 4:
                return (<h5 className={textClass}>{children}</h5>);
            case 5:
                return (<h6 className={textClass}>{children}</h6>);
        }
    }


    if(props.value != null && props.value !== "") {
        return (
            <>
                {renderText()}
            </>

        );
    }




}